import Duck from "redux-ducks-ts"

export const userAppClient = new Duck("userAppClient", "cargo")
